import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux'
import { hashHistory } from 'react-router'
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

const finalCreateStore = compose(
	applyMiddleware(thunk),
	applyMiddleware(routerMiddleware(hashHistory))
)(createStore);

export default function configureStore(initialState) {
	return finalCreateStore(rootReducer, initialState);
}



// WEBPACK FOOTER //
// ./src/store/configureStore.dist.js